import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="sb-footer" role="contentinfo" data-testid="site-footer">
      <div className="container py-5">
        <div className="row g-4">
          <div className="col-lg-4">
            <Link
              to="/"
              className="sb-brand-wrap text-decoration-none"
              aria-label="InstaVivah home"
            >
              <img
                src="https://customer-assets-v7afamib.emergentagent.net/job_vivah-deploy-test/artifacts/ixq288yn_instavivah.png"
                alt="InstaVivah"
                className="sb-brand-logo"
              />
            </Link>
            <p className="mt-3 text-muted" style={{ maxWidth: 320 }}>
              A modern home for a very old tradition. Build a beautiful
              marriage biodata in minutes and find matches from trusted Indian
              families — no signup required to start.
            </p>
          </div>

          <div className="col-6 col-md-3 col-lg-2">
            <h4 className="sb-footer-heading">Product</h4>
            <ul className="list-unstyled sb-footer-list">
              <li><Link to="/biodata/build">Biodata Maker</Link></li>
              <li><Link to="/templates">Templates Gallery</Link></li>
              <li><Link to="/browse">Browse Profiles</Link></li>
              <li><Link to="/register">Create Profile</Link></li>
              <li><Link to="/premium">Premium</Link></li>
            </ul>
          </div>

          <div className="col-6 col-md-3 col-lg-2">
            <h4 className="sb-footer-heading">Company</h4>
            <ul className="list-unstyled sb-footer-list">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div>

          <div className="col-6 col-md-3 col-lg-2">
            <h4 className="sb-footer-heading">Legal</h4>
            <ul className="list-unstyled sb-footer-list">
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/refund">Refund Policy</Link></li>
              <li><Link to="/faq">Help &amp; FAQ</Link></li>
            </ul>
          </div>

          <div className="col-6 col-md-3 col-lg-2">
            <h4 className="sb-footer-heading">Reach us</h4>
            <ul className="list-unstyled sb-footer-list">
              <li>
                <a href="mailto:hello@instavivah.com">
                  hello@instavivah.com
                </a>
              </li>
              <li><Link to="/contact">Support</Link></li>
            </ul>
          </div>
        </div>

        <hr className="my-4" />
        <div className="d-flex flex-wrap gap-3 justify-content-between align-items-center text-muted small">
          <span>© {year} InstaVivah. All rights reserved.</span>
          <span>
            <Link to="/privacy" className="sb-link-quiet me-3">Privacy</Link>
            <Link to="/refund" className="sb-link-quiet me-3">Refunds</Link>
            <Link to="/contact" className="sb-link-quiet">Contact</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
